<template>
  <div class="container">
    <div class="main-content-text">
      <span class="update">Last updated: August 2025</span>
      <h1>Cancellation & Refund Policy – MyCelebrity Wish Feature</h1>
      <p>
        At <strong>MyCelebrity</strong>, we strive to deliver the best experience when fans connect with their favorite celebrities through our Wish Feature. However, we understand that in rare cases, requests may not be fulfilled. This Cancellation & Refund Policy outlines the conditions under which cancellations and refunds apply.
      </p>
      <div class="gap-20"></div>
      <h3>1. Celebrity-initiated Cancellations</h3>
      <p>
        Once a fan makes a payment and places a request, only the celebrity has the right to cancel the request.<br>
        A celebrity may cancel a request if:
      </p>
      <ul>
        <li>The request is deemed spam, offensive, or inappropriate.</li>
        <li>The celebrity is uncomfortable fulfilling the request for personal or professional reasons.</li>
      </ul>
      <p>In such cases, the fan will receive a 100% refund of the payment made.</p>
      <div class="gap-20"></div>
      <h3>2. Non-Delivery by Celebrity</h3>
      <p>
        If a celebrity fails to provide the requested video message within the committed timeline, the fan will be eligible for a full refund.<br>
        Delays caused by technical issues, force majeure, or unforeseen circumstances will be considered case-by-case. If delivery is not possible, the refund will still apply.
      </p>
      <div class="gap-20"></div>
      <h3>3. Fan-Initiated Cancellations</h3>
      <p>
        Once a payment is successfully made, fans cannot cancel their request or claim a refund.<br>
        This ensures fairness and protects the celebrity’s time and commitment.<br>
        Therefore, all fan-initiated cancellations are non-refundable.
      </p>
      <div class="gap-20"></div>
      <h3>4. Refund Timeline</h3>
      <p>
        Approved refunds will be processed to the original mode of payment.<br>
        Refund timelines may vary depending on the payment gateway and bank, typically 5–10 business days.
      </p>
      <div class="gap-20"></div>
      <h3>5. No Refund Cases</h3>
      <p>Refunds will not be applicable in the following scenarios:</p>
      <ul>
        <li>If the fan provides incorrect details (e.g., wrong name, wrong instructions).</li>
        <li>If the fan is dissatisfied with the style, tone, or performance of the celebrity’s video message (as artistic style is subjective).</li>
        <li>If the fan changes their mind after making payment.</li>
      </ul>
      <div class="gap-20"></div>
      <h3>6. Policy Updates</h3>
      <p>
        MyCelebrity reserves the right to update or modify this policy at any time. Any changes will be reflected on this page with a revised effective date.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancellationRefundPolicy",
};
</script>

<style lang="scss" scoped>
.main-content-text {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 15px;
  }

  h1 {
    font-size: 30px;
  }

  h2 {
    font-size: 26px;
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
  }

  h4 {
    font-size: 22px;
  }

  h5 {
    font-size: 18px;
  }

  h6 {
    font-size: 16px;
  }

  ul {
    margin-bottom: 15px;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
  }

  .update {
    display: block;
    font-size: 13px;
    color: #888;
    margin-bottom: 10px;
  }

  .gap-20 {
    height: 20px;
  }
}
</style>
